import * as Sentry from "@sentry/angular";

import { AppConfig } from "../config/app.lib.config";

export function sentryOptions( appConfig: AppConfig ) : Sentry.BrowserOptions {
	return {

		environment: window.location.hostname.split('.', 1)[0], //'local', 'dev', 'stage', 'order'
		dsn: appConfig.sentryDSN,
		integrations: [
			// Registers and configures the Tracing integration,
			// which automatically instruments your application to monitor its
			// performance, including custom Angular routing instrumentation
			Sentry.browserTracingIntegration(),
			// Registers the Replay integration,
			// which automatically captures Session Replays
			Sentry.replayIntegration(),
		],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: appConfig.production ? 0.2 : 1,

		// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: ["localhost", appConfig.apiUrl],

		// Capture Replay for 10% of all sessions (disabled for now),
		// plus for 100% of sessions with an error
		//replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1
	};
}
